import './index.css';
import { Backdrop } from '@mashtrade/ui';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { env } from './env';
import { useFeed } from './feed';
import { PriceBoard } from './components/price-board';

if (env.sentryDsn) {
  Sentry.init({
    dsn: env.sentryDsn,
    // Adds request headers and IP for users
    sendDefaultPii: true,
    integrations: [
      // send console.log, console.warn, and console.error calls as logs to Sentry
      Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
    ],
    tracesSampleRate: 0.01,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

const App = () => {
  useFeed();
  return <PriceBoard />;
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <>
    <Backdrop />
    <Sentry.ErrorBoundary fallback={<p>Something went wrong.</p>}>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </Sentry.ErrorBoundary>
  </>,
);
